import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { apiClient } from '../../../helpers/apiHelperV2';
import Input from '../../components/form-elements/Input';
import Button from '../../components/form-elements/Button';

const zipCodeSchema = Yup.object().shape({
    zipCode: Yup.string()
        .required('Pflichtfeld')
        .test('zipCode', 'Bitte geben Sie eine gültige deutsche PLZ ein', async function (zipCode) {
            if (zipCode && zipCode.length === 5) {
                try {
                    const {
                        data: { isValid },
                    } = await apiClient.post('/api/v1/validation/zipCode', { zipCode });
                    return isValid;
                } catch (err) {
                    console.error(err);
                    return false;
                }
            }
        }),
});

function LocationSelector({ onSubmit }) {
    return (
        <div>
            <div className="uk-background-muted uk-padding" data-uk-margin="">
                <div className="uk-text-large uk-text-center">
                    Geben Sie Ihre <b>Postleitzahl</b> ein und wählen Sie ein
                    <br />
                    <b>Autohaus in Ihrer Nähe.</b>
                    <br />
                    Der Produktpreis erscheint nach der Auswahl.
                </div>
                <Formik
                    initialValues={{ zipCode: '' }}
                    validationSchema={zipCodeSchema}
                    onSubmit={onSubmit}
                    render={({ touched, values, errors, setFieldValue }) => {
                        return (
                            <Form className="uk-form">
                                <Input
                                    name="zipCode"
                                    value={values.zipCode}
                                    placeholder="PLZ eingeben z.B.10117"
                                    onChange={({ name, value }) => setFieldValue(name, value)}
                                    error={touched.zipCode && errors.zipCode ? errors.zipCode : undefined}
                                />
                                <Button fullWidth type="submit">
                                    Lokales Autohaus auswählen
                                </Button>
                            </Form>
                        );
                    }}
                />
            </div>
        </div>
    );
}

export default LocationSelector;
